import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { BsDropdownConfig } from 'ngx-bootstrap';

export interface DropdownModel {
  name: string,
  value: string,
  selected?: boolean
};

@Component({
  selector: 'dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }]
})
export class DropdownComponent implements OnInit {
  activeItem: DropdownModel = {
    name: '',
    value: '',
    selected: false
  };
  @Input() classNames = {};
  @Input() items: Array<DropdownModel> = [];
  @Output() onChange = new EventEmitter();
  @ViewChild('dropdown') ulRef;
  
  constructor() { }
  
  ngAfterViewInit() {
    this.setDropdownScroll();
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.activeItem = null;
    this.items.map((item) => {
      const { selected } = item;
      if (selected) {
        this.activeItem = item;
      }
    });
    this.setDropdownScroll();
    if (!this.activeItem && this.items.length > 0) {
      this.activeItem = this.items[0];
    }
  }

  /**
   * Selects and item from the dropdown.
   */
  selectItem(item) {
    this.activeItem = item;
    this.onChange.emit(this.activeItem);
  }

  setDropdownScroll() {
    setTimeout(() => {
      if (this.ulRef && this.ulRef.nativeElement.clientHeight < 400) {
        this.ulRef.nativeElement.style.overflowY = 'hidden';
      } else if (this.ulRef) {
        this.ulRef.nativeElement.style.overflowY = 'scroll';
      }
    });
  }
}
